
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glossary/web-development-glossary",
      function () {
        return require("private-next-pages/glossary/web-development-glossary.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glossary/web-development-glossary"])
      });
    }
  